module.exports = __webpack_public_path__ + "77ba61fc9a23c932b124c2475e65d99d.png";